import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
var TimelineYears = React.memo(function (_a) {
    var activePeriodIndex = _a.activePeriodIndex, direction = _a.direction, startYear = _a.startYear, endYear = _a.endYear;
    return (_jsxs("div", { className: "timeline__years", children: [_jsx("div", { className: "timeline__year timeline__year--from timeline__year--".concat(direction), children: startYear }, "from-".concat(startYear, "-").concat(activePeriodIndex)), _jsx("div", { className: "timeline__year timeline__year--to timeline__year--".concat(direction), children: endYear }, "to-".concat(endYear, "-").concat(activePeriodIndex))] }));
});
TimelineYears.displayName = 'TimelineYears';
export default TimelineYears;
